import { useState, useEffect } from "react";
import "./SiteGate.scss";

const SITE_ENV = process.env.REACT_APP_SITE_ENV;
const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;
const STORAGE_KEY = "site_gate_password";

function SiteGate({ children }) {
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (SITE_ENV === "production") {
      setAuthorized(true);
      return;
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored === SITE_PASSWORD) {
      setAuthorized(true);
    }
  }, []);

  if (authorized) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, password);
      setAuthorized(true);
      setError("");
    } else {
      setError("Nesprávne heslo");
    }
  };

  return (
    <div className="site-gate">
      <div className="site-gate__card">
        <div className="site-gate__badge">{SITE_ENV.toUpperCase()}</div>
        <h1 className="site-gate__title">Prístup obmedzený</h1>
        <p className="site-gate__text">
          Táto stránka je v režime <strong>{SITE_ENV}</strong>. Pre pokračovanie
          zadajte heslo.
        </p>
        <form className="site-gate__form" onSubmit={handleSubmit}>
          <input
            type="password"
            className="site-gate__input"
            placeholder="Heslo"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
          {error && <span className="site-gate__error">{error}</span>}
          <button type="submit" className="site-gate__btn">
            Vstúpiť
          </button>
        </form>
      </div>
    </div>
  );
}

export default SiteGate;
